import React from 'react';

import './style.scss';
import Button from './../Button';

const SimpleButton = React.memo(({className = '', color = 'color1', ...rest}) => {
  className = `SimpleButton ${className}`;

  return (
    <Button
      className={className}
      animate={false}
      {...rest}
    />
  )
});

export default SimpleButton;